export const PXPullPlannerUpgrade = (function () {
	'use strict';

	function init() {
		if (!document.getElementById('pullPlannerUpgradeForm')) return;

		let upgradeForm = document.getElementById('pullPlannerUpgradeForm');
		let upgradeFormMessage = document.getElementById('pullPlannerUpgradeFormMessage');
		let downloadMessage = document.getElementById('pullPlannerUpgradeFormDownloadMessage');
		let upgradeFormSubmitButton = upgradeForm.querySelector('[type="submit"]');

		upgradeForm.addEventListener('submit', (ev) => {
			ev.preventDefault();

			let today = new Date();
			let params = new URLSearchParams();
			// let dd = String(today.getDate()).padStart(2, '0');
			// let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			// let yyyy = today.getFullYear();

			let message =
				'Pull-Planner 4.0 Upgrade <br/> Date/Time: ' +
				today +
				'<br/>Previous Version: ' +
				upgradeForm.elements['pull_planner_upgrade_version'].value +
				'<br/>Upgraded Version: 2020.1.105' +
				'<br/>Serial Number: ' +
				upgradeForm.elements['pull_planner_upgrade_serial'].value +
				'<br/>Name: ' +
				upgradeForm.elements['pull_planner_upgrade_name'].value +
				'<br/>Company: ' +
				upgradeForm.elements['pull_planner_upgrade_company'].value;

			params.append('action', 'pull_planner_upgrade');
			params.append('message', message);
			params.append('today', today);
			params.append('version', upgradeForm.elements['pull_planner_upgrade_version'].value);
			params.append('serial', upgradeForm.elements['pull_planner_upgrade_serial'].value);
			params.append('name', upgradeForm.elements['pull_planner_upgrade_name'].value);
			params.append('company', upgradeForm.elements['pull_planner_upgrade_company'].value);

			upgradeFormSubmitButton.setAttribute('disabled', true);

			axios
				.post(PXConstants.ajaxUrl, params)
				.then((data) => {
					if (data.data.success) {
						upgradeFormMessage.innerHTML = downloadMessage.innerHTML;
						upgradeForm.style.display = 'none';
					} else {
						upgradeFormSubmitButton.removeAttribute('disabled');
					}
				})
				.catch((err) => console.log(err));
		});
	}

	function events() {}

	return {
		init: init,
	};
})();
